/**
 * Door Blocked Action Types (Tiny Room puzzle)
 */

export const DOOR_BLOCKED_ACTION_ID = 'dungeo.action.door_blocked';

export const DoorBlockedMessages = {
  DOOR_LOCKED: 'dungeo.tiny_room.door_locked'
} as const;
